import { ConfirmDialog } from '@gogame/components';
import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import { removeSmartRule } from 'scenes/SmartRules/sources/smartRules';

import { remove, grids } from '../queryKeyFactory';

export const useRemove = () => {
  const confirm = useScreenModalV2(ConfirmDialog);

  const removeMutation = useMutation(remove(), removeSmartRule, {
    successMessage: () => `Smart Rule deleted`,
    refreshOptions: {
      // TODO: without this entity
      queryKey: grids(),
    },
  });

  const handleRemove = ({ id, name }) =>
    confirm({
      title: `Delete Smart Rule?`,
      bodyText: `${id} ${name}`,
      confirmActionLabel: 'Delete',
    }).then(() => removeMutation.mutateAsync({ id }));

  return [handleRemove, removeMutation];
};
